import script from "./ProjectLimitsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectLimitsTable.vue?vue&type=script&setup=true&lang=js"

import "./ProjectLimitsTable.vue?vue&type=style&index=0&id=295ac955&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295ac955"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
